import styled from 'styled-components'

const Breadcrumbs = styled.div`
    width: 100%;
    border-bottom: 1px solid #ccc;
`;

export const Styled = {
    Breadcrumbs
}